/** @format */

import { tenantPaymentMethodUrl } from '../Config/Url';
import axios from 'axios';

export const tenantPaymentMethodServices = {
	getAllPaymentMethods,
	createPaymentMethod,
	updatePaymentMethod,
	assignPaymentMethod,
	deletePaymentMethod,
};

async function getAllPaymentMethods(id) {
	return axios
		.get(`${tenantPaymentMethodUrl}/all?tenantId=${id}`)
		.then(res => res)
		.catch(err => err.response);
}
async function createPaymentMethod({
	tenantId,
	name,
	tag,
	fiscalTag,
	useFiscalization,
	creditCardIds,
}) {
	return axios
		.post(`${tenantPaymentMethodUrl}`, {
			tenantId,
			name,
			tag,
			fiscalTag,
			useFiscalization,
			creditCardIds,
		})
		.then(res => res)
		.catch(err => err.response);
}

async function updatePaymentMethod(
	tenantPaymentMethodId,
	{
		paymentMethodId,
		name,
		tag,
		fiscalTag,
		useFiscalization,
		isDefault,
		creditCardIds,
	},
) {
	return axios
		.put(`${tenantPaymentMethodUrl}/${tenantPaymentMethodId}`, {
			paymentMethodId,
			name,
			tag,
			fiscalTag,
			useFiscalization,
			creditCardIds,
			isDefault,
		})
		.then(res => res)
		.catch(err => err.response);
}

async function assignPaymentMethod(tenantId, paymentMethodId) {
	return axios
		.post(
			`${tenantPaymentMethodUrl}/assign?tenantId=${tenantId}&paymentMethodId=${paymentMethodId}`,
		)
		.then(res => res)
		.catch(err => err.response);
}

// async function updatePaymentMethod() {}

async function deletePaymentMethod(id) {
	return axios
		.delete(`${tenantPaymentMethodUrl}?tenantPaymentMethodId=${id}`)
		.then(res => res)
		.catch(err => err.response);
}
